export default {
  name: "CheckCircle",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 30C8.28 30 2 23.72 2 16S8.28 2 16 2s14 6.28 14 14-6.28 14-14 14zm0-26C9.38 4 4 9.38 4 16s5.38 12 12 12 12-5.38 12-12S22.62 4 16 4zm-.65 16.99c.27-.03.51-.17.68-.39l5.77-7.63c.33-.44.25-1.07-.19-1.4-.44-.33-1.07-.25-1.4.19l-5.14 6.8-3.8-3.1a1.01 1.01 0 0 0-1.41.14c-.35.43-.28 1.06.14 1.41l4.61 3.75c.2.19.48.26.74.23z",
  },
}
